import $ from 'jquery';
import modaal from 'modaal';
import Cookies from 'js-cookie';
import slick from 'slick-carousel';

class Modal {
    constructor() {
        this.carouselSlideIndex = 0;
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.js-inline-modal').modaal();

        $('.js-internal-video').modaal({
            type: 'inline',
            custom_class: 'modaal-video',
            width: 930
        });

        $('.js-video').modaal({
            type: 'video',
            width: 930
        });

        $('.image-modal').modaal({
            type: 'image',
            width: 930
        });

        $('.carousel-modal').modaal({
            type: 'inline',
            custom_class: 'carousel-modaal',
            before_open: (e) => {
                let $clicked = $(e.currentTarget);

                this.carouselSlideIndex = parseInt($clicked.attr('data-slide'), 10);
            },
            after_open: () => {
                $('<button class="image-gallery-prev"><span class="sr-only">Previous</span><i class="fas fa-arrow-left"></i></button>').appendTo('.modaal-content-container');
                $('<button class="image-gallery-next"><span class="sr-only">Next</span><i class="fas fa-arrow-right"></i></button>').appendTo('.modaal-content-container');

                $('.modaal-container .image-gallery-modal').on('init', (e, slick) => {
                    $('.modaal-container .spinner-wrapper').toggleClass('d-none');
                    $('.modaal-container .image-gallery-modal').toggleClass('d-none');
                });

                $('.modaal-container .image-gallery-modal').slick({
                    mobileFirst: true,
                    dots: false,
                    infinite: true,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    prevArrow: $('.image-gallery-prev'),
                    nextArrow: $('.image-gallery-next')
                });

                $('.modaal-container .image-gallery-modal').slick('slickGoTo', this.carouselSlideIndex, false);
            },
            before_close: () => {
                $('.modaal-container .image-gallery-modal').slick('unslick');
                $('.image-gallery-prev').remove();
                $('.image-gallery-next').remove();

                $('.modaal-container .image-gallery-modal').off('init');

                $('.modaal-container .spinner-wrapper').toggleClass('d-none');
                $('.modaal-container .image-gallery-modal').toggleClass('d-none');
            }
        });

        $('.card-video').modaal({
            type: 'iframe',
            width: 930,
            source: (elem, src) => {
                src = $(elem).attr('href');
                return src;
            }
        });

        // Close when clicking Modaal overlay
        $(document).on('click', (e) => {
            if ($(e.target).hasClass('modaal-outer-wrapper')) {
                $('.image-modal').modaal('close');
                $('.js-video').modaal('close');
                $('.js-inline-modal').modaal('close');
                $(`.carousel-modal[data-slide=${this.carouselSlideIndex}]`).modaal('close');
                $('.card-video').modaal('close');
            }
        });

        $('.js-go-to-nfl').on('click', e => {
            window.location.href = 'https://www.nfl.com/causes/play60/';
        });
    }
}

export default Modal;

$(() => {
    const modal = new Modal();
    modal.init();
});